import React from 'react';
import {
  VictoryAxis,
  VictoryBoxPlot,
  VictoryChart,
  VictoryLabel,
  VictoryScatter,
  VictoryTheme,
} from 'victory';

interface ChartBoxPlotComponentProps {
  mainTitle: string;
  data: object[];
}

const ChartBoxPlotComponent = (props: ChartBoxPlotComponentProps) => {
  return (
    <>
      <VictoryChart
        theme={VictoryTheme.material}
        style={{
          parent: {
            border: '1px solid #CCE8F6',
            borderRadius: '5px',
          },
        }}
        width={500}
        height={300}
      >
        {/* Axes Y */}
        <VictoryAxis
          dependentAxis
          label="Lame d'eau de pluie (mm)"
          style={{
            axisLabel: { padding: 40, fontSize: '10px' },
          }}
        />
        {/* Boxplot */}
        <VictoryBoxPlot
          data={props.data}
          labels
          boxWidth={40}
          style={{
            min: { stroke: '#008BD2' },
            max: { stroke: '#008BD2' },
            q1: { fill: '#008BD2' },
            q3: { fill: '#008BD2' },
            median: { stroke: 'white', strokeWidth: 2 },
            minLabels: { fill: '#008BD2' },
            maxLabels: { fill: '#008BD2' },
          }}
        />
        {/* Moyenne */}
        <VictoryScatter
          style={{
            data: { fill: 'black' },
            labels: { fill: 'black', fontSize: 14 },
          }}
          size={4}
          data={[{ x: 1, y: 3, symbol: 'diamond', size: 5 }]}
          labels={({ datum }) => `moy : ${datum.y}`}
        />
        {/* Labels */}
        <VictoryLabel
          x={80}
          y={10}
          text={props.mainTitle}
        />
      </VictoryChart>
    </>
  );
};

export default ChartBoxPlotComponent;
